<mat-toolbar color="primary">
  <span>Prep Service</span>
  <span class="example-spacer"></span>
  <button mat-button *ngFor="let item of menu" [routerLink]="item.redirect">{{ item.nombre }}</button>
  <span class="example-spacer"></span>
  <button mat-icon-button class="example-icon" routerLink="/" aria-label="">
    <mat-icon>logout</mat-icon>
  </button>
</mat-toolbar>
